export default __webpack_public_path__ + "static/media/bay.fd622c88.svg";